import React from "react";

export default function IconPlay(props) {
  return (
    <svg viewBox="0 0 23 23" {...props}>
      <circle id="Oval" fill="none" strokeWidth="2" cx="11.5" cy="11.5" r="10.5" />
      <path d="M8.5,8.3 C8.5,7.74771525 8.94771525,7.3 9.5,7.3 C9.68741972,7.3 9.87106734,7.35266944 10.0299989,7.4520017 L15.1432027,10.6477541 C15.6115392,10.9404644 15.7539124,11.5574148 15.4612021,12.0257513 C15.3807214,12.1545204 15.2719718,12.26327 15.1432027,12.3437507 L10.0299989,15.539503 L10.0299989,15.539503 C9.87106734,15.6388353 9.68741972,15.6915047 9.5,15.6915047 C8.98716416,15.6915047 8.56449284,15.3054645 8.50672773,14.8081258 L8.5,14.6915047 L8.5,8.3 Z" />
    </svg>
  );
}
